import React from 'react'
import PropTypes from 'prop-types'
import Markdown from 'markdown-to-jsx'

export const HTMLDisplay = ({ html }) => {
  return (
    <Markdown
      options={{
        overrides: {
          p: {
            props: { style: { margin: '0px' } }
          }
        }
      }}
    >
      {html}
    </Markdown>
  )
}

HTMLDisplay.propTypes = {
  html: PropTypes.node,
}
